import { render, staticRenderFns } from "./course-record.vue?vue&type=template&id=0ff9838a&"
import script from "./course-record.vue?vue&type=script&lang=ts&"
export * from "./course-record.vue?vue&type=script&lang=ts&"
import style0 from "./course-record.vue?vue&type=style&index=0&id=0ff9838a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports